"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackMediaInteraction = trackMediaInteraction;
const browser_core_1 = require("@datadog/browser-core");
const browser_rum_core_1 = require("@datadog/browser-rum-core");
const types_1 = require("../../../types");
const eventsUtils_1 = require("../eventsUtils");
const assembly_1 = require("../assembly");
function trackMediaInteraction(configuration, scope, mediaInteractionCb) {
    return (0, browser_core_1.addEventListeners)(configuration, document, ["play" /* DOM_EVENT.PLAY */, "pause" /* DOM_EVENT.PAUSE */], (event) => {
        const target = (0, eventsUtils_1.getEventTarget)(event);
        if (!target) {
            return;
        }
        const id = scope.nodeIds.get(target);
        if (id === undefined ||
            (0, browser_rum_core_1.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === browser_rum_core_1.NodePrivacyLevel.HIDDEN) {
            return;
        }
        mediaInteractionCb((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.MediaInteraction, {
            id,
            type: event.type === "play" /* DOM_EVENT.PLAY */ ? types_1.MediaInteractionType.Play : types_1.MediaInteractionType.Pause,
        }));
    }, {
        capture: true,
        passive: true,
    });
}
//# sourceMappingURL=trackMediaInteraction.js.map